/** The exact proposal reviewed by the user. Delivery markers are excluded so
 * a retry of an already accepted send can still return its persisted outcome. */
export function martinaEmailDraftApproval(draft: unknown): string {
  const value = (draft && typeof draft === 'object' ? draft : {}) as Record<string, unknown>;
  return JSON.stringify([
    'martina-email-draft-v1',
    ...['type', 'text', 'subject', 'to', 'accountId', 'recipientContactId',
      'sourceMessageId', 'threadId', 'mode', 'editedAt'].map((key) => value[key] ?? null),
  ]);
}

/** Local composer review. Its fingerprint never authorizes the chat send route. */
export interface MartinaEmailComposerReview {
  fingerprint: string;
  from: string;
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  text: string;
  attachments: string[];
}
export type MartinaEmailComposerReviewReader = (draft: string) => MartinaEmailComposerReview | null | Promise<MartinaEmailComposerReview | null>;
export type MartinaEmailComposerApprovedSend = (draft: string, approvedFingerprint: string) => boolean;
